import './componenteTablaDark.css'
export default function EstadoComponenteTablaDark({ stro, estados }) {
    return (
        <th className='textoBodyTablaDark'>
            <div className='d-flex align-items-center gap-2'>
                <div className={stro.estadoNuevo === 203 ? "circleRojoEstadoTablaDark" : stro.estadoNuevo === 200 ? "circleGrisEstadoTablaDark" : "circleVerdeEstadoTablaDark"}></div> {estados.find((e) => e.id === Number(stro.estadoNuevo))?.abreviacion}
            </div>
        </th>
    );
}
